import { Pipe, PipeTransform } from '@angular/core';
import { resolveImageUrl } from '../utils/image-url';

/**
 * Binds a stored product image URL (`imageName` / `cardData.image`) to `<img src>`.
 *
 * The backend stores those gateway-relative (`/api/v2/image/mirror/...`); this re-roots them
 * onto `environment.apiUrl` where that is absolute. See `resolveImageUrl` for the rule. Pure:
 * the answer depends on the value and a build-time constant only.
 *
 * It ALWAYS answers a loadable string: the stored value is nullable, and a null bound to
 * `[src]` is sanitised through `String(value)` into a request for the literal `"null"`. So a
 * row with no picture resolves to `environment.defaultImageMagic` here, and a template must
 * NOT gate the `<img>` on the raw value -- that is what used to leave an empty cell.
 */
@Pipe({ name: 'appImageUrl', standalone: true })
export class AppImageUrlPipe implements PipeTransform {
  transform(value: unknown): string {
    return resolveImageUrl(value);
  }
}
